<script lang="ts">
  import { onMount } from "svelte";
  import { link } from "svelte-spa-router";
  import { verifyEmail, ApiError } from "../lib/api";

  /** Route params injected by svelte-spa-router: { token }. */
  export let params: { token?: string } = {};

  let state: "loading" | "ok" | "fail" = "loading";

  onMount(async () => {
    const token = params.token ?? "";
    if (!token) {
      state = "fail";
      return;
    }
    try {
      await verifyEmail(token);
      state = "ok";
    } catch (err) {
      void (err instanceof ApiError);
      state = "fail";
    }
  });
</script>

<section class="verify">
  <div class="card">
    <h1>Email verification</h1>
    {#if state === "loading"}
      <p class="sub" data-testid="verify-loading">Verifying your email…</p>
    {:else if state === "ok"}
      <p class="sub ok" data-testid="verify-ok">
        Your email is verified. You can now sign in.
      </p>
      <a href="/" use:link>→ Go to sign in</a>
    {:else}
      <p class="sub error" data-testid="verify-fail">
        This verification link is invalid or has expired. Sign in and request a
        new verification email.
      </p>
      <a href="/" use:link>← Back to sign in</a>
    {/if}
  </div>
</section>

<style>
  .verify {
    min-height: 60vh;
    display: grid;
    place-items: center;
    padding: 1rem;
  }
  .card {
    width: 100%;
    max-width: 420px;
    background: #111827;
    border: 1px solid #1f2937;
    border-radius: 12px;
    padding: 1.5rem;
  }
  h1 {
    margin: 0 0 0.5rem;
    font-size: 1.25rem;
  }
  .sub {
    margin: 0 0 1rem;
    color: #9ca3af;
    line-height: 1.5;
  }
  .ok {
    color: #6ee7b7;
  }
  .error {
    color: #fca5a5;
  }
  a {
    color: #34d399;
    text-decoration: none;
  }
  a:hover {
    text-decoration: underline;
  }
</style>
